declare namespace $ {

	type $mol_hotkey__key_bog_smalljs_search_1 = $mol_type_enforce<
		({ 
			escape( next?: ReturnType< $bog_smalljs_search['close'] > ): ReturnType< $bog_smalljs_search['close'] >,
		}) 
		,
		ReturnType< $mol_hotkey['key'] >
	>
	type $mol_hotkey__key_bog_smalljs_search_2 = $mol_type_enforce<
		({ 
			down( next?: ReturnType< $bog_smalljs_search['select_next'] > ): ReturnType< $bog_smalljs_search['select_next'] >,
		}) 
		,
		ReturnType< $mol_hotkey['key'] >
	>
	type $mol_hotkey__key_bog_smalljs_search_3 = $mol_type_enforce<
		({ 
			up( next?: ReturnType< $bog_smalljs_search['select_prev'] > ): ReturnType< $bog_smalljs_search['select_prev'] >,
		}) 
		,
		ReturnType< $mol_hotkey['key'] >
	>
	type $mol_view__event_bog_smalljs_search_4 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $bog_smalljs_search['close'] > ): ReturnType< $bog_smalljs_search['close'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_string__value_bog_smalljs_search_5 = $mol_type_enforce<
		ReturnType< $bog_smalljs_search['query'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_smalljs_search_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__submit_bog_smalljs_search_7 = $mol_type_enforce<
		ReturnType< $bog_smalljs_search['activate'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_view__sub_bog_smalljs_search_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_bog_smalljs_search_9 = $mol_type_enforce<
		ReturnType< $bog_smalljs_search['result_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_smalljs_search_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_search_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_search_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_bog_smalljs_search_13 = $mol_type_enforce<
		ReturnType< $bog_smalljs_search['result_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__event_click_bog_smalljs_search_14 = $mol_type_enforce<
		ReturnType< $bog_smalljs_search['pick'] >
		,
		ReturnType< $mol_link['event_click'] >
	>
	type $mol_link__attr_bog_smalljs_search_15 = $mol_type_enforce<
		({ 
			'bog_smalljs_search_current': ReturnType< $bog_smalljs_search['result_current'] >,
		})  & ReturnType< $mol_link['attr'] >
		,
		ReturnType< $mol_link['attr'] >
	>
	type $mol_link__sub_bog_smalljs_search_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	export class $bog_smalljs_search extends $mol_view {
		Escape( ): $mol_hotkey
		Nav_down( ): $mol_hotkey
		Nav_up( ): $mol_hotkey
		Backdrop( ): $mol_view
		Field( ): $mol_string
		Hint( ): $mol_view
		result_rows( ): readonly(any)[]
		Results( ): $mol_list
		Panel( ): $mol_view
		result_arg( id: any): Record<string, any>
		result_current( id: any): boolean
		result_title( id: any): string
		Result_title( id: any): $mol_view
		result_snippet( id: any): string
		Result_snippet( id: any): $mol_view
		open( next?: boolean ): boolean
		query( next?: string ): string
		anchor_key( ): string
		close( next?: any ): any
		focus( next?: any ): any
		activate( next?: any ): any
		select_next( next?: any ): any
		select_prev( next?: any ): any
		pick( id: any, next?: any ): any
		attr( ): ({ 
			'bog_smalljs_search_open': ReturnType< $bog_smalljs_search['open'] >,
		}) 
		plugins( ): readonly($mol_plugin)[]
		sub( ): readonly(any)[]
		Result( id: any): $mol_link
	}
	
}

//# sourceMappingURL=search.view.tree.d.ts.map